import { render, staticRenderFns } from "./ItemBadge.vue?vue&type=template&id=13ba0435&scoped=true&"
import script from "./ItemBadge.vue?vue&type=script&lang=js&"
export * from "./ItemBadge.vue?vue&type=script&lang=js&"
import style0 from "./ItemBadge.vue?vue&type=style&index=0&id=13ba0435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba0435",
  null
  
)

export default component.exports